import { css, jsx } from '@emotion/core';
import { useRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';

import ChartProfiles from '@/src/profile/ChartProfiles';
import Breadcrumbs from '@/src/shared/components/Breadcrumbs';
import Container from '@/src/shared/components/Container';
import Divider from '@/src/shared/components/Divider';
import Heading from '@/src/shared/components/Heading';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import { bp, colors } from '@/styles';
import request from '@/utils/axios';

const style = {
  section: css`
    padding-bottom: 200px !important;
    @media ${bp.md} {
      padding-bottom: 75px !important;
    }
  `,
  title: css`
    margin-bottom: 24px;
    @media print {
      font-size: 2.6rem;
      line-height: 3.2rem;
    }
  `,
  breadcrumbs: css`
    left: 0;
    margin-top: -32px !important;
    position: absolute;
    right: 0;
    width: 100%;
    z-index: 3;
  `,
  info: css`
    color: ${colors.secondaryGray};
    font-size: 1.6rem;
    margin-top: -24px !important;
  `,
  contactUs: css`
    font-weight: 800;
    color: ${colors.secondaryBlue};
  `,
  divider: css`
    @media print {
      display: none;
    }
  `,
};

const SeniorStaff = props => {
  const router = useRouter();

  const { data, isLoggedIn } = props;

  const { route } = router;
  const enableBio = true;
  const { PageTitle, Profiles } = data;

  return (
    <Layout>
      <Section css={style.section}>
        <Container css={[style.breadcrumbs]}>
          <Breadcrumbs theme="dark" />
          <Divider type="red" css={style.divider} />
          <Heading type={1} theme="jumbo" css={[style.title]}>
            {PageTitle}
          </Heading>
          {!isLoggedIn ? (
            <div css={style.info}>
              To contact a member of APCIA&apos;s Senior Staff, please use our{' '}
              <a css={style.contactUs} href="/about/contact-us/form">
                {' '}
                Contact Us{' '}
              </a>{' '}
              form.
            </div>
          ) : null}
        </Container>
      </Section>
      <Section css={style.section}>
        <Container>
          <ChartProfiles profiles={Profiles} route={route} enableBio={enableBio} seniorStaff />
        </Container>
      </Section>
      <WebLogImage title={PageTitle} path="/about/leadership/senior-staff" />
    </Layout>
  );
};

export async function getStaticProps() {
  try {
    const response = await request({
      url: `profile/chartprofiles`,
      method: 'GET',
      params: {
        chartid: 1,
      },
    });
    const { data } = response;

    return { props: { data } };
  } catch (err) {
    return { props: { data: undefined, error: true } };
  }
}

export default connect(state => {
  const { auth } = state;
  const { isLoggedIn } = auth;
  return { isLoggedIn };
})(SeniorStaff);
